import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/(main)/activity-board')({
    beforeLoad: () => {
        throw redirect({
            to: '/activity',
            search: { presentation: 'board' },
            replace: true,
        });
    },
    head: () => ({
        meta: [
            {
                title: 'Activity | Phoebe',
            },
        ],
    }),
});
